export default "__VITE_ASSET__DkijK1b___"